<template>
  <div class="look-sensor">
    <div class="in-crib-title">
      <div class="handle-wrapper" @click="backHistory">
        <div class="icon-font">&#xe612;</div>
        <a>返回</a>
      </div>
      <div class="in-crib-item">传感器入垛</div>
      <div class="handle-wrapper" @click="handleIn">
        <div class="icon-font">&#xe606;</div>
        <a>入垛</a>
      </div>
    </div>
    <div class="look-sensor-content">
      <div class="look-sensor-content-top">
        <div class="in-crib-info">
          <div class="info-left">
            <div class="info-select">
              <div class="info-select-msg">传感器ID：</div>
              <div class="info-select-msg">X：</div>
            </div>
            <div class="info-select">
              <DropDownInput
                type="0"
                :items="sensorValue"
                content=""
                @sendValue="sendValue"
                @sendInfo="showInfo"
              ></DropDownInput>
              <div class="input-wrapper">
                <input v-model="tableItem.siteX" />
              </div>
            </div>
            <div class="info-select">
              <div class="info-select-msg">传感器类型：</div>
              <div class="info-select-msg">Y：</div>
            </div>
            <div class="info-select">
              <div class="input-wrapper">
                <input disabled="true" v-model="nodeTypeName" />
              </div>
              <div class="input-wrapper">
                <input v-model="tableItem.siteY" />
              </div>
            </div>
            <div class="info-select">
              <div class="info-select-msg">位置：</div>
              <div class="info-select-msg">Z：</div>
            </div>
            <div class="info-select">
              <LoadingTreeStack
                :moduleType="moduleType"
                :content="tableItem.name"
                :editCheckId="treeId"
                v-on:sendInfo="showDropInfo"
              ></LoadingTreeStack>
              <div class="input-wrapper">
                <input v-model="tableItem.siteZ" />
              </div>
            </div>
          </div>
          <div class="info-right">
            <div class="handle-wrapper" @click="addTable">
              <div class="icon-font">&#xe605;</div>
              <a>添加</a>
            </div>
          </div>
        </div>
        <div class="sensor-title-list">
          <div class="in-crib-list-title">序号</div>
          <div class="in-crib-list-title">传感器ID</div>
          <div class="in-crib-list-title">传感器类型</div>
          <div class="in-crib-list-title">坐标</div>
          <div class="in-crib-list-title">垛位</div>
          <div class="in-crib-list-title">操作</div>
        </div>
      </div>
      <div class="none-data" v-if="totalData.length === 0">暂无数据</div>
      <div class="look-sensor-content-center" v-if="totalData.length !== 0">
        <div
          class="sensor-content-bottom-list"
          v-for="(data, index) in tableData"
          :key="index"
        >
          <div class="in-crib-list-title">{{ index + 1 }}</div>
          <div class="in-crib-list-title">{{ data.nodeId }}</div>
          <div class="in-crib-list-title">{{ data.nodeTypeName }}</div>
          <div class="in-crib-list-title">
            X:{{ data.siteX }}&nbsp;&nbsp;Y:{{ data.siteY }}&nbsp;&nbsp;Z:{{
              data.siteZ
            }}
          </div>
          <div class="in-crib-list-title">
            <el-popover
              placement="top"
              title=""
              trigger="hover"
              :content="data.name"
              ><div class="in-crib-list-title-gatherSite" slot="reference">
                {{ data.name }}
              </div></el-popover
            >
          </div>
          <div class="in-crib-list-title">
            <div class="detail-btn item-delete" @click="deleteTable(index)">
              删除
            </div>
          </div>
        </div>
      </div>
      <div class="page-wrapper" v-if="totalData.length > 8">
        <div class="page-wrapper-left">
          共{{ total }}条数据,共{{ Allpages }}页，每页显示{{ rows }}条，当前第{{
            page
          }}页
        </div>
        <div class="page-wrapper-right">
          <div class="page-btn" @click="firstPage">首页</div>
          <div class="page-btn" @click="previousPage">上一页</div>
          <div class="page-btn" @click="Tzpage">跳转至</div>
          <div class="page-btn"><input v-model="page" /></div>
          <div class="page-btn" @click="nextPage">下一页</div>
          <div class="page-btn" @click="lastPage">尾页</div>
        </div>
      </div>
    </div>
    <img class="look-sensor-icon" src="../../../../assets/content-box.png" />
    <transition name="fade">
      <div class="alert-box" v-if="show">
        <div class="alert-content">
          <div class="alert-content-title">删除提醒</div>
          <div class="alert-content-msg">是否确认删除选中数据?</div>
          <div class="alert-content-btn">
            <div class="btn-cancel button" @click="cancelDelete">取消</div>
            <div class="btn-confirm button" @click="confirmDelete">确认</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import DropDownInput from '../../../../components/DropDownInput.vue'
import LoadingTreeStack from '../../../../components/LoadingTreeStack.vue'
// eslint-disable-next-line no-unused-vars
import {
  bathDelQualityTesting,
  delQualityTesting,
  findNodeLike,
  nodesIntoStack,
} from '../../../../api/maintain'
import { noEmpty } from '../../../../tools/methods'
import localforage from 'localforage'
export default {
  name: "TimeInCrib",
  components: { DropDownInput, LoadingTreeStack },
  data() {
    return {
      moduleType: '',
      treeId: '',
      title: '',
      nodeId: '',
      nodeTypeName: '',
      tableItem: {
        id: '',
        nodeTypeName: '',
        name: '',
        nodeId: '',
        nodeType: '',
        siteId: '',
        siteType: '',
        siteX: '',
        siteY: '',
        siteZ: ''
      },
      page: 1,
      rows: 8,
      total: "",
      // 总页数
      Allpages: 0,
      totalData: [],
      tableData: [],
      sensorValue: [],
      show: false,
    };
  },
  created() {
    this.moduleType = this.$route.query.moduleType;
    this.handleSearch();
  },
  methods: {
    sendValue: function (value) {
      console.log(value)
      this.handleSearch(value)
    },
    handleSearch: function (value) {
      let body = {
        nodeId: value,
      };
      findNodeLike(body)
        .then((res) => {
          console.log(res)
          this.sensorValue = res.data;
        })
        .catch((err) => {
          console.log(err)
        });
    },
    backHistory: function () {
      this.$router.go(-1)
    },
    showInfo: function (data) {
      this.nodeTypeName = data.nodeTypeName
      this.tableItem.nodeId = data.nodeId
      this.tableItem.id = data.id
      this.tableItem.nodeType = data.nodeType
      this.tableItem.nodeTypeName = data.nodeTypeName
      console.log(data)
    },
    showDropInfo: function (data) {
      console.log(data)
      this.tableItem.name = data.name
      this.tableItem.siteId = data.id
      this.tableItem.siteType = data.siteType
    },
    addTable: function () {
		console.log(this.page)
      console.log(this.tableItem)
      let canAdd = true
      if (
        noEmpty(this.tableItem.nodeId, "请选择传感器ID") &&
        noEmpty(this.tableItem.siteId, "请选择传位置") &&
        noEmpty(this.tableItem.siteX, "请输入X坐标") &&
        noEmpty(this.tableItem.siteY, "请输入Y坐标") &&
        noEmpty(this.tableItem.siteZ, "请输入Z坐标")
      ) {
        this.totalData.map((item) => {
          if (item.id === this.tableItem.id) {
            canAdd = false
          }
        })
        if (canAdd) {
          this.totalData.push({
            name: this.tableItem.name,
            nodeTypeName: this.tableItem.nodeTypeName,
            nodeId: this.tableItem.nodeId,
            id: this.tableItem.id,
            nodeType: this.tableItem.nodeType,
            siteId: this.tableItem.siteId,
            siteType: this.tableItem.siteType,
            siteX: this.tableItem.siteX,
            siteY: this.tableItem.siteY,
            siteZ: this.tableItem.siteZ,
          })
        } else {
          this.$message({
            message: "该传感器已经添加！",
            type: "warning",
            center: "true",
            duration: "1000",
          })
        }
        this.total = this.totalData.length;
        // 计算总页数
        this.Allpages = Math.ceil(this.total / this.rows);
		this.page=this.Allpages;
        if (this.totalData.length < 9) {
          this.tableData = this.totalData;
        } else {
          this.tableData = this.totalData.slice(
            this.page * 8 - 8,
            this.page * 8
          )
        }
      }
    },
    deleteTable: function (id) {
      this.show = true;
      this.id = id;
      // console.log(this.id)
      this.type = 0;
    },
    cancelDelete: function () {
      this.show = false
    },
    confirmDelete: function () {
		console.log(this.page)
      if (this.type === 0 && this.page <=2) {
		  if(this.totalData.length <  9){
			   this.totalData.splice(this.id, 1);
		  }else{
			  this.totalData.splice(parseInt(this.id +(this.page-1)*8), 1);
		  }
      }else{
		  console.log(parseInt(this.id +(this.page-1)*8))
		  this.totalData.splice(parseInt(this.id +(this.page-1)*8), 1);
	  }
      this.$message({
        message: "删除成功!",
        type: "success",
        center: "true",
        duration: "1000",
      })
      this.show = false;
      this.total = this.totalData.length;
	  this.Allpages = Math.ceil(this.total / this.rows);
	  this.page=this.Allpages;
      if (this.totalData.length <  9) {
        this.tableData = this.totalData;
      } else {
        this.tableData = this.totalData.slice(this.page * 8 - 8, this.page * 8);
      }
      this.handleSearch();
    },
    handleIn: function () {
      if (this.totalData.length === 0) {
        this.$message({
          message: "请先添加！",
          type: "warning",
          center: "true",
          duration: "1000",
        })
      } else {
        console.log(this.totalData);
        let arr = [];
        this.tableData.map((data) => {
          arr.push({
            name: data.name,
            nodeId: data.nodeId,
            id: data.id,
            nodeType: data.nodeType,
            siteId: data.siteId,
            siteType: data.siteType,
            siteX: data.siteX,
            siteY: data.siteY,
            siteZ: data.siteZ,
          })
        })
        nodesIntoStack(JSON.parse(JSON.stringify(arr)))
          .then((res) => {
            console.log(res);
            this.$message({
              message: "入垛成功！",
              type: "success",
              center: "true",
              duration: "1000",
            })
          })
          .catch((err) => {
            console.log(err);
          })
      }
    },
    firstPage: function () {
      console.log("首页");
      if (this.page === 1) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        })
      } else {
        this.page = 1;
        this.tableData = this.totalData.slice(this.page * 8 - 8, this.page * 8);
      }
    },
    Tzpage: function () {
      console.log("跳转页面");
      if (this.page === 1) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else if (this.page >= this.Allpages) {
        this.$message({
          message: "总页数为" + this.Allpages,
          type: "warning",
          center: "true",
          duration: "1000",
        })
        this.page = this.Allpages;
        this.tableData = this.totalData.slice(this.page * 8 - 8, this.page * 8);
      } else {
        this.tableData = this.totalData.slice(this.page * 8 - 8, this.page * 8);
      }
    },
    previousPage: function () {
      console.log("上一页");
      if (this.page < 2) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        })
      } else {
        this.page--;
        this.tableData = this.totalData.slice(this.page * 8 - 8, this.page * 8);
      }
    },
    nextPage: function () {
      console.log("下一页");
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++;
        this.tableData = this.totalData.slice(this.page * 8 - 8, this.page * 8);
      } else {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        })
      }
    },
    lastPage: function () {
      console.log("尾页");
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        })
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows);
        } else {
          this.page = parseInt(this.total / this.rows) + 1;
        }
        this.tableData = this.totalData.slice(this.page * 8 - 8, this.page * 8);
      }
    },
  },
};
</script>

<style scoped>
@import "Time.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/core/timeMonitoring/TimeInCrib.vue